export default __webpack_public_path__ + "static/media/116.fa07630e.png";